//Globalising jQuery so when third-party plugins are loaded in they have access otherwise jQuery will get defined after the third-party plugins load.
import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;